import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Close from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import Counter from "../Counter";

import styles from "./styles";

import { changeOrderQuantity, removeCartItem } from "../../actions";
import { getPrice } from "../../reducers";

let CartItem = ({
  classes,
  canUpdate,
  id,
  disabled,
  title,
  quantity,
  optionTitle,
  optionName,
  price,
  onQuantityChange,
  onRemoveClick,
  thumbnail
}) => {
  return (
    <div className={classes.container}>
      <img className={classes.preview} src={thumbnail} alt={title} />
      <div className={classes.details}>
        <p className={classes.title}>{title}</p>
        {optionTitle && (
          <small>
            {optionTitle}: {optionName}
          </small>
        )}
        <Counter
          className={classes.counter}
          value={quantity}
          disabled={!canUpdate || disabled}
          onChange={onQuantityChange}
        />
        <p className={classNames(classes.price)}>${price}</p>
      </div>
      {!disabled && (
        <Close className={classes.removeButton} onClick={onRemoveClick} />
      )}
    </div>
  );
};

CartItem.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array,
  productId: PropTypes.string.isRequired,
  optionId: PropTypes.string,
  quantity: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  optionTitle: PropTypes.string,
  optionName: PropTypes.string,
  canUpdate: PropTypes.bool.isRequired,
  thumbnail: PropTypes.string.isRequired
};

const mapStateToProps = (state, { productId, optionId }) => {
  const product = state.products[productId];
  let option;
  if (optionId) {
    const [opt] = product.options.filter(o => o.id === optionId);
    option = opt;
  }
  return {
    title: product.title,
    price: getPrice({ productId, optionId, state }),
    canUpdate: !product.single,
    optionTitle: product.optionTitle,
    optionName: option ? option.name : "",
    thumbnail: product.thumbnail,
    disabled: state.checkout.loading
  };
};
const mapDispatchToProps = (dispatch, { productId, optionId }) => ({
  onQuantityChange: quantity =>
    dispatch(changeOrderQuantity({ productId, optionId, quantity })),
  onRemoveClick: () => dispatch(removeCartItem({ productId, optionId }))
});
CartItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(CartItem);

export default withStyles(styles)(CartItem);



// WEBPACK FOOTER //
// ./src/components/OrderItem/index.js